import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import moment from 'moment';
import queryString from 'query-string';
import LZString from 'lz-string';
import { connect } from 'react-redux';
import ReactResizeDetector from 'react-resize-detector';
import { Tab, Tabs, Button, Overlay, ButtonGroup } from 'react-bootstrap';
import { Link, withRouter } from 'react-router-dom';
import enhanceWithClickOutside from 'react-click-outside';
import pluralize from 'pluralize';
import { map, indexOf, keys, pick, isArray, reduce, isString, isNumber, omit, each, filter, defer } from 'lodash';
import Fa from 'react-fontawesome';

import ProgressBar from '../progress-bar';
import GroupField from './group-field';
import SaveSearchForm from './save-search-form';
import SaveSearchList from './save-search-list';
import ConfirmButton from '../confirm-button';
import LinkButton from './link-button';
import TeamSelector from './team-selector';

import { getViewableDimensions } from '../../modules/App/AppReducer';
import {
  getLoading,
  getHasErrors,
  getCloseDateRange,
  getFilterStatsConditions,
  getIsDirty,
  getErrors,
  getSearchFilters,
  getSearchQuery,
  getSearchDefaultQuery,
  cleanSubmitCriteria,
  getSavedSearches,
  getSavedSearch,
} from './search-form-reducer';
import {
  initSearchForm,
  initSimpleSearchForm,
  submitSearch,
  resetDefault,
} from './search-form-actions';
import {
  getIsSuperAdmin,
  getIsAdmin,
  getIsOrganizationAdmin,
  getIsUsingOrganizationSwitch,
} from '../../modules/Auth/AuthReducer';
import { getFilters } from '../../modules/Setup/FilterReducer';

import styles from './styles.css';

function compressedParams(rootQuery) {
  /*
  rootQuery = {
    type: 'groupAND' || 'groupOR'
    values: [
      {
        _id:
        type: 'include' || 'exclude'
        values: [string], // can be a string 'last-12-months'
        mappings: [string]
      }
    ]
  }
  */
  const translated = {
    groupAND: 'A',
    groupOR: 'O',
    include: 'I',
    exclude: 'E',
    set: 'S',
  };

  const translateNode = (node) => {
    const v = isArray(node.values) ? reduce(node.values, (item, val) => {
      if (isString(val) || isNumber(val)) {
        item.push(val);
      } else if (val === null) {
        item.push(null);
      } else {
        item.push(translateNode(val));
      }
      return item;
    }, []) : node.values;
    const newNode = { t: translated[node.type] || node.type };
    if (node._id) {
      newNode.i = node._id;
    }
    if (node.filter_id) {
      newNode.f = node.filter_id;
    }
    if (v && v.length) {
      newNode.v = v;
    }
    const m = node.mappings;
    if (m && m.length) {
      newNode.m = m;
    }
    return newNode;
  };
  return translateNode(rootQuery);
}

function decompressParams(rootQuery) {
  const translated = {
    A: 'groupAND',
    O: 'groupOR',
    I: 'include',
    E: 'exclude',
    S: 'set',
  };

  const translateNode = (node) => {
    const v = isArray(node.v) ? reduce(node.v, (item, val) => {
      if (isString(val) || isNumber(val)) {
        item.push(val);
      } else {
        item.push(translateNode(val));
      }
      return item;
    }, []) : node.v;
    const newNode = { type: translated[node.t] || node.t };
    if (node.i) {
      newNode._id = node.i;
    }
    if (node.f) {
      newNode.filter_id = node.f;
    }
    if (v && v.length) {
      newNode.values = v;
    }
    const { m } = node;
    if (m && m.length) {
      newNode.mappings = m;
    }
    return newNode;
  };
  return translateNode(rootQuery);
}

const FormOverlay = ({ children, className, pullRight }) => (
  <div className={`${styles.formOverlay} ${className} ${pullRight ? styles.formOverlayRight : ''}`}>
    {children}
  </div>
);
FormOverlay.propTypes = {
  children: PropTypes.element,
  className: PropTypes.string,
  pullRight: PropTypes.bool,
};
FormOverlay.defaultProps = {
  pullRight: false,
  className: null,
  children: null,
};

class SearchForm extends Component {
  constructor(props) {
    super(props);
    let selectedTeam = null;
    if (props.showTeamSelector && !props.requireTeamSelector) {
      if (props.selectDefaultTeam) {
        selectedTeam = { is_default: true };
      }
    } else {
      selectedTeam = { _id: null };
    }
    this.state = {
      disabled: true,
      show: false,
      confirmingReset: false,
      enableRootClose: true,
      reseting: false,
      selectedTab: 'current',
      searchURI: null,
      // selectedTeam: props.requireTeamSelector ? null : { _id: null },
      selectedTeam,
      containerHeight: 0,
    };
    this.submit = this.submit.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.deleteCriteria = this.deleteCriteria.bind(this);
    this.updateCriteria = this.updateCriteria.bind(this);
    this.handleTabSelect = this.handleTabSelect.bind(this);
    this.resetSearch = this.resetSearch.bind(this);
    this.handleTeamChange = this.handleTeamChange.bind(this);
    this.handleSaveSearchLoaded = this.handleSaveSearchLoaded.bind(this);
    this.calculateContainerSize = this.calculateContainerSize.bind(this);
    this.showSearchForm = this.showSearchForm.bind(this);
  }

  componentDidMount() {
    this.loadForm(true);
    /*
    this.loadForm(true)
      .then(
        () => {
          this.cleanUpURL();
        },
      );
    */
  }

  broadcastContext(params) {
    const { searchContext } = this.props;
    const context = reduce(pick(params, keys(searchContext)), (items, v, k) => {
      items[k] = decodeURIComponent(v);
      return items;
    }, {});
    this.props.onSearchContextChange(context);
  }

  loadForm(parseURL = false) {
    const {
      queryParams, type,
      defaultCriteria,
      location,
      isDynamic,
      simpleMode,
      mainFilters,
    } = this.props;
    let { loadRecommendedCriteria } = this.props;
    this.setState({ disabled: true });
    const params = queryString.parse(location.search);
    let urlCriteria = null;
    if (parseURL) {
      if (params.q) {
        try {
          const compressedQuery = LZString.decompressFromEncodedURIComponent(params.q);
          if (compressedQuery) {
            const query = decompressParams(JSON.parse(compressedQuery));
            urlCriteria = query;
            loadRecommendedCriteria = false;
          }
        } catch (e) {
          urlCriteria = null;
        }
      }
    }
    const action = simpleMode ? 
      initSimpleSearchForm(mainFilters, type, queryParams, defaultCriteria, isDynamic) : 
      initSearchForm(type, queryParams, defaultCriteria, loadRecommendedCriteria, urlCriteria, isDynamic, simpleMode);

    const p = this.props.dispatch(action);
    p.then(
      (results) => {
        const context = parseURL ? params : (results.context || {});
        if (results.savedSearch) {
          const { savedSearch } = results;
          if (savedSearch.team__id) {
            // select team
            this.waitSelectedTeam()
              .then(
                () => {
                  this.setState({ selectedTeam: { _id: savedSearch.team__id } }, () => {
                    this.handleSearchChange(results, context);
                  });
                },
              );
          } else if (this.props.requireTeamSelector) {
            // no team in the save search
            // and this require team?
            // do nothing
            this.handleSearchChange(results, context);
          /*
          } else if (this.props.selectDefaultTeam) {
            this.waitSelectedTeam()
              .then(
                () => {
                  this.handleSearchChange(results, context);
                },
              );
          */
          } else {
            // un select team
            this.setState({ selectedTeam: { _id: null } }, () => {
              this.handleSearchChange(results, context);
            });
          }
        } else {
          this.handleSearchChange(results, context);
        }
      },
      (error) => {
        this.props.onLoadError(error);
        this.setState({ disabled: false });
      },
    );
    return p;
  }

  cleanUpURL() {
    // clean up after receive params
    const { location, searchContext } = this.props;
    const { pathname, search } = location;
    const query = omit(queryString.parse(search), ['q', keys(searchContext)]);
    this.context.router.history.replace({ pathname, query });
  }

  submit(context = {}) {
    const {
      filterQueryParams, queryParams, searchQuery,
      type,
    } = this.props;
    this.setState({ disabled: true, selectedTab: 'current' });
    const params = cleanSubmitCriteria(searchQuery);
    this.props.dispatch(submitSearch(type, { ...filterQueryParams, ...queryParams }, params))
      .then(
        (results) => {
          this.handleSearchChange(results, context);
        },
        (error) => {
          this.props.onLoadError(error);
          this.setState({ disabled: false });
        },
      );
  }

  showSearchForm() {
    this.setState({ show: !this.state.show });
  }

  calculateContainerSize(w, containerHeight) {
    this.setState({ containerHeight });
  }

  handleSaveSearchLoaded(savedSearch) {
    if (savedSearch.team__id) {
      // select team
      this.setState({ selectedTeam: { _id: savedSearch.team__id } }, () => {
        this.submit(savedSearch.context);
      });
    } else if (this.props.requireTeamSelector) {
      // no team in the save search
      // and this require team?
      // do nothing
      this.submit(savedSearch.context);
    /*
    } else if (this.props.selectDefaultTeam) {
      this.setState({ selectedTeam: { is_default: true } }, () => {
        this.submit(savedSearch.context);
      });
    */
    } else {
      // un select team
      this.setState({ selectedTeam: { _id: null } }, () => {
        this.submit(savedSearch.context);
      });
    }
  }

  handleClickOutside() {
    const { enableRootClose } = this.state;
    if (enableRootClose) {
      this.setState({ show: false });
    }
  }

  waitSelectedTeam() {
    if (!this.teamPromiseCache) {
      this.teamPromiseCache = new Promise((resolve) => {
        this.teamPromiseCacheResolver = resolve;
      });
    }
    return this.teamPromiseCache;
  }

  handleTeamChange(selectedTeam, teamLoaded = false) {
    this.setState({ selectedTeam }, () => {
      this.waitSelectedTeam(); // just to init the resolver
      if (teamLoaded && this.teamPromiseCacheResolver) {
        this.teamPromiseCacheResolver();
      }
    });
  }

  handleSearchChange({ query }, context = {}) {
    const { standalone, showTeamSelector } = this.props;
    const p = (standalone || !showTeamSelector) ? Promise.resolve() : this.waitSelectedTeam();
    p.then(
      () => {
        const { filterQueryParams, queryParams, closeDateRange } = this.props;
        // const cleanCriteria = cleanSubmitCriteria(query);
        this.updateURL(query);
        this.broadcastContext(context);
        this.props.onSearchChange({
          ...filterQueryParams,
          ...queryParams,
          query,
          team: this.state.selectedTeam,
        });
        this.props.onCloseDateRangeChange(closeDateRange);
        this.setState({ disabled: false, show: false });
      },
    );
  }

  updateURL(params) {
    const { searchContext } = this.props;
    const newSearch = {};
    const cp = compressedParams(params);
    const encoded = LZString.compressToEncodedURIComponent(JSON.stringify(cp));
    newSearch.q = encoded;
    each(searchContext, (v, k) => {
      newSearch[k] = encodeURIComponent(v);
    });
    this.setState({ searchURI: newSearch });
  }

  deleteCriteria(ids) {
    const { searchQuery } = this.props;
    this.props.deleteCriteria([searchQuery._id, ...ids]);
  }

  updateCriteria(ids, params) {
    const { searchQuery } = this.props;
    this.props.updateCriteria([searchQuery._id, ...ids], params);
  }

  handleTabSelect(selectedTab) {
    this.setState({ selectedTab });
  }

  resetSearch() {
    const { type } = this.props;
    if (!this.state.reseting) {
      this.props.onReset();
      this.setState({ reseting: true }, () => {
        this.props.dispatch(resetDefault(type))
          .then(
            () => {
              this.setState({ reseting: false });
              this.submit();
            },
            () => {
              this.setState({ reseting: false });
            },
          );
      });
    }
  }

  renderTeamSelector() {
    const { disabled, selectedTeam } = this.state;
    const { requireTeamSelector } = this.props;
    const teamBlock = (
      <TeamSelector
        isRequired={requireTeamSelector}
        disabled={disabled}
        selectedTeam={selectedTeam}
        onTeamChange={this.handleTeamChange}
      />
    );
    if (this.teamFieldHolder && this.state.show) {
      return ReactDOM.createPortal(teamBlock, this.teamFieldHolder);
    }
    return teamBlock;
  }

  renderRootField() {
    const {
      loading, disabledRootLogic, type,
      searchQuery, systemFilters, overrideFields,
      searchFilters, disabledFilters,
      dropup, readOnly, isDynamic, startingNode, standalone,
    } = this.props;
    const { disabled } = this.state;
    if (loading) {
      return (
        <div className={`${styles.searchForm} ${standalone ? styles.searchFormStandAlone : ''}`}>
          <div className={styles.searchFormBody}>
            <ProgressBar />
          </div>
        </div>
      );
    }

    const newSearchFilters = map(searchFilters, searchFilter => ({ ...searchFilter, disabled: indexOf(disabledFilters, searchFilter.tag) >= 0 }));
    return (
      <>
        {this.renderWearningMessage()}
        <GroupField
          groupCriteria={searchQuery}
          path={[searchQuery._id]}
          disabled={(disabled || this.props.disabled)}
          disabledLogic={disabledRootLogic}
          overrideFields={overrideFields}
          isRoot
          showRootLogicalORWarning={this.props.showRootLogicalORWarning}
          isDynamic={isDynamic}
          startingNode={startingNode}
          modalModel
          dropdownRef={this.dropdownRef}
          dropup={dropup}
          searchFilters={newSearchFilters}
          systemFilters={systemFilters}
          onModalShow={() => { this.setState({ enableRootClose: false }); }}
          onModalHide={() => { this.setState({ enableRootClose: true }); }}
          deleteCriteria={this.deleteCriteria}
          updateCriteria={this.updateCriteria}
          searchType={type}
          readOnly={readOnly}
          customFooterControls={this.props.customFooterControls}
        />
      </>
    );
  }

  renderChildren() {
    const { children, renderChildrenAsPlain } = this.props;
    if (renderChildrenAsPlain) {
      return children;
    }
    return (
      <div className={`${styles.fieldGroup} ${styles.field} ${styles.fieldGroupRoot}`} style={{ marginBottom: '5px' }}>
        <div className={styles.fieldGroupBody}>
          {children}
        </div>
      </div>
    );
  }

  renderWearningMessage() {
    const { searchQuery, showRootLogicalORWarning } = this.props;
    if (!showRootLogicalORWarning) {
      return null;
    }
    const isRootOR = searchQuery && searchQuery.type === 'groupOR' && searchQuery.values?.length > 1;
    if (!isRootOR) {
      return null;
    }
    return (
      <div className={`text-warning animated flash ${styles.warningMessage}`}>
        <div><Fa name="exclamation-triangle" /> <strong>Warning:</strong> Logical <code>OR</code> is active on root filter set. This means the whole filter group will be qualified if ANY of the root filters below is qualified.</div>
      </div>
    );
  }

  renderForm() {
    const {
      loading, hasErrors, errors, type,
      searchQuery, canManageFilters,
      savedSearches, children,
      viewableDimensions,
      isDirty, standalone, showTeamSelector,
      hideLinkButton,
    } = this.props;
    const {
      disabled, selectedTab, selectedTeam,
      containerHeight,
    } = this.state;
    const mySearches = filter(savedSearches, (ss) => {
      return ss.is_automation !== true;
    });
    if (loading) {
      return (
        <div className={`${styles.searchForm} ${standalone ? styles.searchFormStandAlone : ''}`}>
          <div className={styles.searchFormBody}>
            <ProgressBar />
          </div>
        </div>
      );
    }

    if (hasErrors) {
      return (
        <div className="alert alert-danger">{errors && errors.messge ? errors.messge : 'Please try again'}</div>
      );
    }
    const hasChildren = children && typeof children !== 'undefined';

    const { height } = viewableDimensions;
    const maxHeight = height * 0.6;
    const scroll = containerHeight >= maxHeight || height < 1000; // https://github.com/lumen-software/TruSales/issues/1489
    const stl = {};
    if (scroll) {
      stl.maxHeight = maxHeight;
      stl.overflowX = 'hidden';
      stl.overflowY = 'auto';
      stl.paddingRight = '20px';
    }

    return (
      <div className={`${styles.searchForm} ${standalone ? styles.searchFormStandAlone : ''}`}>
        <Tabs
          activeKey={selectedTab}
          onSelect={this.handleTabSelect}
          id="search-form-tabs"
          animation={false}
        >
          <Tab
            eventKey="current"
            title="Current Filter"
          >
            <div>
              <div style={stl}>
                <div>
                  <ReactResizeDetector handleHeight onResize={this.calculateContainerSize} />
                  <div className={styles.searchFormInstruction}>
                    <div className="well well-sm" style={{ margin: 0 }}>
                      <Fa name="info-circle" /> Add one or more filters to narrow down the list of items.
                    </div>
                  </div>
                  <div className={styles.searchFormBody}>
                    {showTeamSelector && <div ref={(el) => { this.teamFieldHolder = el; }} />}
                    {hasChildren && this.renderChildren()}
                    {this.renderRootField()}
                  </div>
                </div>
              </div>
              <div style={{ position: 'relative' }} ref={(el) => { this.dropdownRef = el; }} />
              <div className={styles.searchFormFooter}>
                <div className="clearfix">
                  <div className="pull-left" style={{ paddingTop: 5 }}>
                    {canManageFilters && <Link to="/setup/filters"><Fa name="cogs" /> Configure</Link>}
                    {canManageFilters && <span>&nbsp;&nbsp;&nbsp;</span>}
                    {!hideLinkButton && <LinkButton params={this.state.searchURI} />}
                  </div>
                  <div className="pull-right">
                    <div className="text-right">
                      {isDirty && !loading && <Button bsStyle="link" onClick={this.resetSearch}><span className="text-danger">Reset</span></Button>}
                      <SaveSearchForm
                        disabled={disabled}
                        savedSearch={{
                          type,
                          criteria: searchQuery,
                          context: this.props.searchContext,
                          existent_id: '0',
                          teamId: selectedTeam ? selectedTeam._id : null,
                        }}
                        teamId={(selectedTeam ? selectedTeam._id : null)}
                        onModalShow={() => { this.setState({ enableRootClose: false }); }}
                        onModalHide={() => { this.setState({ enableRootClose: true }); }}
                        onCreate={() => { this.submit(); }}
                        type={type}
                      >
                        <span>Save</span>
                      </SaveSearchForm>
                      <Button bsStyle="primary" disabled={disabled} onClick={this.submit}>
                        {!disabled && <span>Apply</span>}
                        {disabled && <span><Fa name="spinner" spin /></span>}
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Tab>
          <Tab
            eventKey="saved"
            title={
              <span>
                Saved Filters
                {mySearches.length > 0 && <span>&nbsp;<span className="badge">{mySearches.length}</span></span>}
              </span>
            }
          >
            <SaveSearchList
              disabled={disabled}
              onModalShow={() => { this.setState({ enableRootClose: false }); }}
              onModalHide={() => { this.setState({ enableRootClose: true }); }}
              type={type}
              source={this.props.source}
              onFilterSetLoad={this.handleSaveSearchLoaded}
            />
          </Tab>
        </Tabs>
      </div>
    );
  }

  render() {
    const {
      loading, searchQuery, pullRight, disabled, children, savedSearch, isDirty,
      standalone, showTeamSelector,
    } = this.props;
    const {
      show, confirmingReset, reseting, selectedTeam,
    } = this.state;
    let total = (filter((searchQuery || {}).values || [], criterion => (criterion.values && criterion.values.length) ||
        (criterion.mappings && criterion.mappings.length))).length;

    if (children !== null) {
      if (isArray(children)) {
        total += children.length;
      } else if (typeof children === 'object') {
        total += 1;
      }
    }
    if (standalone) {
      return (
        <div>
          {children !== null && children !== undefined && this.renderChildren()}
          {this.renderRootField()}
        </div>
      );
    }

    if (selectedTeam && selectedTeam._id) {
      total += 1;
    }
    let icon = 'search';
    if (loading) {
      icon = 'spinner';
    }
    return (
      <div style={{ position: 'relative' }}>
        <ButtonGroup>
          {!confirmingReset &&
            <Button active={show} disabled={loading || disabled} ref={(el) => { this.target = el; }} onClick={this.showSearchForm}>
              <Fa
                name={icon}
                className={total > 0 ? 'text-active' : ''}
                spin={loading}
              />
              {!loading &&
                <span>
                  &nbsp;&nbsp;
                  {total > 0 && <span>{total} {pluralize('Filter', total)}</span>}
                  {total === 0 && <span>No Filters</span>}
                  &nbsp;Applied&nbsp;<Fa name="caret-down" />
                </span>
              }
            </Button>
          }
          {((savedSearch !== null && savedSearch !== undefined) || isDirty) && !loading &&
            <ConfirmButton
              disabled={loading || disabled || reseting}
              confirmStyle="danger"
              confirmMessage="Reset to Default Filters?"
              onConfirm={this.resetSearch}
              onConfirmActive={(c) => { this.setState({ confirmingReset: c }); }}
            >
              <Fa name="times-circle" />
            </ConfirmButton>
          }
        </ButtonGroup>
        {showTeamSelector && <div style={{ display: 'none' }}>{this.renderTeamSelector()}</div>}
        <Overlay
          show={show}
          onHide={() => this.setState({ show: false })}
          placement="left"
          container={this}
          target={() => this.target}
        >
          <FormOverlay pullRight={pullRight}>
            {this.renderForm()}
          </FormOverlay>
        </Overlay>
      </div>
    );
  }
}

SearchForm.propTypes = {
  dispatch: PropTypes.func.isRequired,
  onLoadError: PropTypes.func,
  onSearchChange: PropTypes.func,
  searchQuery: PropTypes.shape({
    _id: PropTypes.string.isRequired,
  }).isRequired,
  onReset: PropTypes.func,
  searchFilters: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  mainFilters: PropTypes.arrayOf(PropTypes.shape({})),
  loading: PropTypes.bool.isRequired,
  hasErrors: PropTypes.bool.isRequired,
  errors: PropTypes.shape({
    messge: PropTypes.string,
  }),
  defaultCriteria: PropTypes.shape({}),
  filterQueryParams: PropTypes.shape({}).isRequired,
  systemFilters: PropTypes.arrayOf(PropTypes.string),
  pullRight: PropTypes.bool,
  disabledRootLogic: PropTypes.bool,
  disabled: PropTypes.bool,
  disabledFilters: PropTypes.arrayOf(PropTypes.string),
  overrideFields: PropTypes.objectOf(PropTypes.shape({
    attributes: PropTypes.shape({}),
    component: PropTypes.func, // { stage: <StageComponent> }
  })),
  children: PropTypes.node,
  renderChildrenAsPlain: PropTypes.bool,
  closeDateRange: PropTypes.arrayOf(PropTypes.instanceOf(moment)),
  onCloseDateRangeChange: PropTypes.func,
  type: PropTypes.string.isRequired,
  queryParams: PropTypes.shape({}),
  loadRecommendedCriteria: PropTypes.bool,
  savedSearch: PropTypes.shape({}),
  savedSearches: PropTypes.arrayOf(PropTypes.shape({})),
  isDirty: PropTypes.bool,
  updateCriteria: PropTypes.func,
  deleteCriteria: PropTypes.func,
  location: PropTypes.shape({
    search: PropTypes.string.isRequired,
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  searchContext: PropTypes.shape({}),
  onSearchContextChange: PropTypes.func,
  canManageFilters: PropTypes.bool,
  requireTeamSelector: PropTypes.bool,
  selectDefaultTeam: PropTypes.bool,
  standalone: PropTypes.bool,
  customFooterControls: PropTypes.node,
  dropup: PropTypes.bool,
  viewableDimensions: PropTypes.shape({
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
  }).isRequired,
  readOnly: PropTypes.bool,
  isDynamic: PropTypes.bool,
  startingNode: PropTypes.string,
  source: PropTypes.string,
  showTeamSelector: PropTypes.bool,
  showRootLogicalORWarning: PropTypes.bool,
  simpleMode: PropTypes.bool, // do not load saved searches
};

SearchForm.defaultProps = {
  onReset: () => {},
  onLoadError: () => {},
  onSearchChange: () => {},
  updateCriteria: () => {},
  deleteCriteria: () => {},
  savedSearches: [],
  disabled: false,
  pullRight: false,
  disabledRootLogic: false,
  defaultCriteria: {
    type: 'groupAND',
    values: [
      {
        tag: 'closeDate',
        type: 'include',
        values: 'last-12-months',
      },
    ],
  },
  systemFilters: ['closeDate', 'size', 'stage', 'dealType', 'opportunityRecordType', 'accountIndustry',
    'product', 'repType', 'repRegion', 'tenure', 'forecast', 'competitor', 'requestedFeedbacks',
    'opportunityStageHistories', 'createdDate', 'opportunityAge', 'repProfile', 'repRole',
    'dayPush', 'pushFrequency', 'employeeCount', 'annualRevenue', 'opportunityAccountOwner',
    'hasContacts', 'excluded', 'closedOpportunities', 'openOpportunities', 'firstFeedbackRequested', 'lastFeedbackRequested', 'accountFirstFeedbackRequested', 'accountLastFeedbackRequested', 'reminderEmails',
    'opportunityLastEditor', 'opportunityCreator', 'opportunityOwner', 'lastStageChangeDate', 'opportunityStatus'],
  disabledFilters: [],
  overrideFields: {},
  closeDateRange: [],
  onCloseDateRangeChange: () => {},
  queryParams: {},
  loadRecommendedCriteria: false,
  isDirty: false,
  savedSearch: null,
  children: null,
  renderChildrenAsPlain: false,
  errors: null,
  searchContext: {},
  onSearchContextChange: () => {},
  canManageFilters: false,
  requireTeamSelector: false,
  selectDefaultTeam: false,
  standalone: false,
  customFooterControls: null,
  dropup: false,
  readOnly: false,
  isDynamic: false,
  startingNode: 'Opportunity',
  source: 'opportunity',
  showTeamSelector: true,
  hideLinkButton: false,
  showRootLogicalORWarning: false,
  simpleMode: false,
  mainFilters: [],
};

SearchForm.contextTypes = {
  router: PropTypes.shape({}).isRequired,
};

// Retrieve data from store as props
function mapStateToProps(state, ownProps) {
  const searchType = ownProps.type;
  const canManageFilters = getIsSuperAdmin(state) || getIsAdmin(state) || getIsOrganizationAdmin(state) || getIsUsingOrganizationSwitch(state);
  return {
    loading: getLoading(searchType, state),
    hasErrors: getHasErrors(searchType, state),
    errors: getErrors(searchType, state),
    searchFilters: getSearchFilters(searchType, state),
    searchQuery: ownProps.readOnly ? getSearchDefaultQuery(searchType, state) : getSearchQuery(searchType, state),
    closeDateRange: getCloseDateRange(searchType, state),
    filterQueryParams: getFilterStatsConditions(searchType, state),
    savedSearch: getSavedSearch(searchType, state),
    savedSearches: getSavedSearches(searchType, state),
    isDirty: getIsDirty(searchType, state),
    viewableDimensions: getViewableDimensions(state),
    canManageFilters,
    mainFilters: getFilters(state),
  };
}

export default connect(mapStateToProps)(withRouter(enhanceWithClickOutside(SearchForm)));
